import pluralize from "pluralize";
import type { FunctionComponentWithRef } from "react";

import {
  CommentText,
  Container,
  StyledButton,
  StyledCommentIcon,
  StyledCommentWrapper,
} from "./styles";

type Props = {
  className?: string;
  commentCount: number;
  onClick?: () => void;
};

export const Article20CommentsBanner: FunctionComponentWithRef<Props, HTMLDivElement> = ({
  className,
  commentCount,
  onClick,
  ref: forwardReference,
}) => (
  <Container className={className} ref={forwardReference}>
    <StyledButton onClick={onClick}>
      <StyledCommentWrapper>
        <StyledCommentIcon />
      </StyledCommentWrapper>
      <CommentText>
        {(commentCount ?? 0) > 0 ? (
          <>
            <strong>{commentCount}</strong> <span>{pluralize("Comment", commentCount)}</span>
          </>
        ) : (
          <span>Comment</span>
        )}
      </CommentText>
    </StyledButton>
  </Container>
);
Article20CommentsBanner.displayName = "Article20CommentsBanner";
